import { SuccessionAllocationSummary } from '@/components/planning/succession/SuccessionAllocationSummary';
import { SuccessionDocumentSlots } from '@/components/planning/succession/SuccessionDocumentSlots';
import { SuccessionSettingsLinks } from '@/components/planning/succession/SuccessionSettingsLinks';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/language-hooks';
import { useDefaultCurrency } from '@/lib/utils';

/** Lightweight loading shell — safe for PageSkeleton Suspense fallback (no API hooks). */
export function SuccessionTabLoadingShell() {
  const { t } = useLanguage();
  const currency = useDefaultCurrency();

  return (
    <div className='flex flex-col gap-6' aria-busy='true' aria-live='polite'>
      <SuccessionAllocationSummary
        estateTotal={0}
        currency={currency}
        beneficiaries={[]}
        parties={[]}
        percents={[]}
        selectedBeneficiaryId={null}
        onSelectBeneficiary={() => undefined}
        onAddFromParty={() => undefined}
        onRemoveBeneficiary={() => undefined}
        allocationMode='simple'
        onAllocationModeChange={() => undefined}
        interactive={false}
        isLoading
        isEstateLoading
      />

      <SuccessionSettingsLinks />

      <SuccessionDocumentSlots
        documents={[]}
        linkedDocumentIds={[]}
        onLink={() => undefined}
        onUnlink={() => undefined}
        isLoading
      />

      <Button type='button' disabled>
        {t('common.save')}
      </Button>
    </div>
  );
}
